module.exports = __webpack_public_path__ + "media/images/icon/arrow-up-0d425b9ed6ff07cb5fc61c23afa01665.svg";